// import React from 'react';
import Button from "@material-ui/core/Button";
import globals from "mson/lib/globals";

import attach from "mson-react/lib/attach";

import React from "react";

class FormNavigationField extends React.PureComponent {
  // classes = useStyles();

  searchEnabled = globals._path === "/search" ? true : false;
  scanEnabled = globals._path === "/" ? true : false;
  render() {
    return (
      <div
        style={{
          margin: "auto",
          width: "100%",
          textAlign: "center",
          marginBottom: "11px",
        }}
      >
        <Button
          variant="contained"
          style={{ margin: "auto", marginRight: "10px" }}
          onClick={() => {
            globals.redirect("/search");
          }}
          disabled={this.searchEnabled}
        >
          Search
        </Button>
        <Button
          variant="contained"
          style={{ margin: "auto" }}
          onClick={() => {
            globals.redirect("/");
          }}
          disabled={this.scanEnabled}
        >
          Scan
        </Button>
      </div>
    );
  }
}
const returnValue = attach(["processor", "ready"])(FormNavigationField);

export default returnValue;
